import { motion } from "framer-motion";
import { fadeUp, staggerChild, staggerContainer } from "../lib/motion";

const haves = ["Reach", "Trust", "Inbound interest", "Existing offers or clear monetization upside"];
const missing = [
  "Clear offer architecture",
  "Stronger conversion paths",
  "Monetization that fits the brand",
  "Operational systems built for growth",
  "Infrastructure that doesn't rely on constant improvisation",
];

export const ValueProposition = () => {
  return (
    <section
      data-testid="value-prop-section"
      className="relative py-24 md:py-32 lg:py-44 px-6 md:px-12 lg:px-20 max-w-[1500px] mx-auto"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <motion.div {...fadeUp} className="flex items-center gap-3 mb-6">
            <span className="eyebrow">01 — Value</span>
            <span className="block w-8 h-px bg-[#282930]" />
          </motion.div>
          <motion.h2
            {...fadeUp}
            className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight"
          >
            Turn attention into a business with{" "}
            <span className="italic text-[#C9A26B]">structure.</span>
          </motion.h2>

          <motion.p
            {...fadeUp}
            className="mt-8 text-[#A8A39D] leading-relaxed max-w-[42ch]"
          >
            Most creators don&rsquo;t have a demand problem. They have a backend
            problem.
          </motion.p>
        </div>

        <div className="lg:col-span-7 lg:pl-12 lg:border-l lg:border-[#282930]">
          <motion.div {...staggerContainer} className="grid md:grid-cols-2 gap-12">
            <div>
              <p className="eyebrow text-[#A8A39D] mb-6">They already have</p>
              <ul className="space-y-3">
                {haves.map((h) => (
                  <motion.li
                    key={h}
                    {...staggerChild}
                    className="flex items-start gap-3 text-[#F4EFE6]"
                  >
                    <span className="mt-3 block w-2 h-px bg-[#C9A26B] flex-shrink-0" />
                    <span>{h}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
            <div>
              <p className="eyebrow text-[#A8A39D] mb-6">What&rsquo;s missing</p>
              <ul className="space-y-3">
                {missing.map((m) => (
                  <motion.li
                    key={m}
                    {...staggerChild}
                    className="flex items-start gap-3 text-[#F4EFE6]"
                  >
                    <span className="mt-3 block w-2 h-px bg-[#A8A39D] flex-shrink-0" />
                    <span>{m}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>

          <motion.p
            {...fadeUp}
            className="mt-14 pt-10 border-t border-[#282930] font-display text-xl md:text-2xl leading-snug text-[#F4EFE6] max-w-[54ch]"
          >
            Chadow Marketing builds the layer behind the brand&mdash;so revenue
            is more predictable, delivery is cleaner, and growth no longer
            depends on manual effort.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
